import { EvmNFTCollection } from '@repo/types-client';

import { baseContractAddresses } from './base-contract-addresses';

export interface BaseNFTCollections {
  readonly avatar: EvmNFTCollection;
  readonly wearable: EvmNFTCollection;
  readonly pass: EvmNFTCollection;
  readonly redeemable: EvmNFTCollection;
  readonly pack: EvmNFTCollection;
}

export const baseNFTCollections: BaseNFTCollections = {
  avatar: {
    contractName: 'Avatar',
    getAddress: () => baseContractAddresses.avatar,
    getMetadataURI: (tokenId: string) => tokenId,
    tokenType: 'ERC7401',
    chain: 'base',
  },
  wearable: {
    contractName: 'Wearable',
    getAddress: () => baseContractAddresses.wearable,
    getMetadataURI: (tokenId: string) => tokenId,
    tokenType: 'ERC7401',
    chain: 'base',
  },
  pass: {
    contractName: 'Pass',
    getAddress: () => baseContractAddresses.pass,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://QmZHGzsFFn94J66kZPqEC5wxuwBYKtWPWKhM8u467oNkgJ';
        case '1':
          return 'ipfs://QmQUJwPL8snT3ZtcdvMowunrFkvQ8JBxUaDsvprMFKGw6d';
        case '2':
          return 'ipfs://QmX3UxRQr1Ny5Cs5JvVQxbGhaLnZUBJKUJvTD1q7ezmKyZ';
        case '3':
          return 'ipfs://QmUUThovjXYZsTsbuB6fmeiMNjaot6XyHBz8dVbtNabjRR';
        case '4':
          return 'ipfs://QmcLqtYQZVqjPwzNW8E2fQP1uRzgmYepyhcSzDmEZaXi1K';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'base',
  },
  redeemable: {
    contractName: 'Redeemable',
    getAddress: () => baseContractAddresses.redeemable,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://QmcZ6SFrEqw1qjBemPbym4MTed5yNgFn6hZrXiN3P6bfXC';
        case '1':
          return 'ipfs://QmZ5mMmXFAUdL898RYPPFhYkbVyiuCbCvd8sQLx5TGraH4';
        case '2':
          return 'ipfs://QmQP1bj9g3DQcxKGh62hunMLGWJvZAygWwPHQP8ftnYs9m';
        case '3':
          return 'ipfs://QmSA4YSVhi2jTmXBtaNcJZQdEB1Eq8ahm7svuLfAGr1Y4V';
        case '4':
          return 'ipfs://QmR8p57NfgTcQNz2aFhyED2Py72coJtsPYUj148x4dPcCf';
        case '5':
          return 'ipfs://QmdQzyTu6RxfXT1sZhz6wkJYQMmcdDG79JbxfD5pLdWcUX';
        case '6':
          return 'ipfs://QmVnfKrPStfkEGMhDJeWYmELhRjpCkDP3Qp1TuFMnNBTgJ';
        case '7':
          return 'ipfs://Qma1aQdMtT5jXdTUTPMiEhEzsEUpcRf95CMS7i5E6uKGjP';
        case '8':
          return 'ipfs://QmdmJRhDT6M2HcsGpXkDA8u4ZLw9x16BNoW9GW5RDukBTh';
        case '9':
          return 'ipfs://Qmavm9nKmJRuyHraEX4aYw2gVSmFTQRG6JVZDaNVgumd4G';
        case '10':
          return 'ipfs://QmNztmSk5s82C21MmYWCLttinTkrLxSJhV6xUm2Z1rVVth';
        case '11':
          return 'ipfs://QmPHmgKLuiyjzkfdL9d9cBCRd8deu7KLCYyBu8ogUu9Y8o';
        case '12':
          return 'ipfs://QmZZKXnwHdphmsXXxsCuPmDUbWLbVosR7yyqVB87sPaMTr';
        case '13':
          return 'ipfs://QmQbru7Cb7bp5NpCTzA4KtaWhMFckEggUMdVhFLNskZ359';
        case '14':
          return 'ipfs://QmVT1xVkpEtrcgvqEjKXu23ZvKWeJqZtvXK7FbHfUS8y8b';
        case '15':
          return 'ipfs://bafkreicgtkwv4icgkeh6m3nalxwsvk6dent3b2dugmkakgwrcl6owakhxe';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'base',
  },
  pack: {
    contractName: 'Pack',
    getAddress: () => baseContractAddresses.pack,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://QmTEHM7f2m71j1SNyj3aGQpxpZ53wD8hHwrzPx89nBsNux';
        case '1':
          return 'ipfs://QmPQoZUnHXJUPS4Jd69zkUpeCMoSnw3uPjnshXAt8R3Snq';
        case '2':
          return 'ipfs://QmX5LjBVR78i9RcRSe6WFaGvHdQkv77qgqef89mLcxUY28';
        case '3':
          return 'ipfs://QmNteQP3xPwXt1xj9t4G1C2ojeTTyBSAD92b4GVwJVhcF8';
        case '4':
          return 'ipfs://QmRQ2qutvRkWe3qJKbRca3g9S9h1eFkYeSiYFPCTtmVKHz';
        case '5':
          return 'ipfs://QmW761dTac5hL93t4WpXUQQnV3nVkudcb3AYLHtV6du62D';
        case '6':
          return 'ipfs://QmYnC2UCLsH576qXUBQgGqiZccUTwdhQJCALxeZzgPhQiZ';
        case '7':
          return 'ipfs://QmbXUjFk4J4RkiLpT8ukxBB2VM6A6TYMUarz83umB6ioqz';
        case '8':
          return 'ipfs://Qmcro5tZaH4ct4kSEbGFw1jApZJYiNw7PeZda71MQ5ot2R';
        case '9':
          return 'ipfs://QmSTiTG9sDkgkqM1Gs8hA5h8ULVJXu36UsA4wyegty27a3';
        case '10':
          return 'ipfs://QmdU1SRXzb4T8xx4VYZzdqmtuBtUBBBzVGxSmv61BMEHEa';
        case '11':
          return 'ipfs://QmNgKdduUNYYVkED3gx7a3jyjuYv5FgDVVrXrRFsa7xi6T';
        case '12':
          return 'ipfs://Qmdvu2y6TcsYCtAUET4nY3wcxALdxD13ArTmCxF7b9bsSR';
        case '13':
          return 'ipfs://QmTcS4XdmcU9NXShVfiiZb6q8RSFDCEC5yZSEVynbMdV5P';
        case '14':
          return 'ipfs://QmShrZhoZGiKJfDt5rn6r3BRc9BX9jvCqbXCmeHtqNEdY7';
        case '15':
          return 'ipfs://QmdgUzhs5AhLtY3ctMs2Wamoi2DRAjt2xqsVUeWTE1ELKo';
        case '16':
          return 'ipfs://QmTpKRZbUxHCZ4ytV47xibERKeFdHAhQkMciFgQqcMoito';
        case '17':
          return 'ipfs://QmQD4h1Dkkn75ZKSFXDtmW6kehpCkckStRazCdUgp7m9g1';
        case '18':
          return 'ipfs://QmQBjPQnJfY2m9CGwUNse1TfDaCdMMZvkzZxp3RriuN4cp';
        case '19':
          return 'ipfs://QmPFA2ehSgZ5ZifPKu6p7UH9DYQv1m3MQT6FUqyts1GJGK';
        case '20':
          return 'ipfs://QmTSmamkLg49yezs9aTkR8m2BkXjzizKjVBzieMjnM2YiZ';
        case '21':
          return 'ipfs://QmWd6uBrc4NBkPf3KnZBz5b9JMcVfAuERCqorjxkf8oydZ';
        case '22':
          return 'ipfs://QmetbVUeP8D8cDkMcSKKb9WzpF91JcV8FABiFqcQUN86iC';
        case '23':
          return 'ipfs://QmUtGswsZFkvYLgiz5jsqABBe2G2pd38w3GhtmFZrqFAgC';
        case '24':
          return 'ipfs://Qmc54ZY1VcW35YJGoeUXKQUies6Qfo3gt5o8n7q3ToL3hH';
        case '25':
          return 'ipfs://bafkreidvvvnjneeswkwtvihprjyk2syagyqxs5trvg53jfzo5ngogrnsii';
        case '26':
          return 'ipfs://bafkreigfwhzfarsed4dnrn6xfh5oqicinbr5x4k4sqfndfr5eitf4fnoly';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'base',
  },
} as const;
